import { ref } from 'vue';

export const isBounce = ref(0);
